import { Spacer } from '@zapier/design-system';
import { clsx } from 'clsx';
import React from 'react';

const header = "_header_heod5_1";
const toprow = "_toprow_heod5_10";
const styles = {
	header: header,
	toprow: toprow
};

const PageHeaderBase = ({ topRowContent, children, className }) => {
  return React.createElement(
    "div",
    { className: clsx(styles.header, className), "data-zds": true },
    topRowContent ? React.createElement("div", { className: styles.toprow, "data-zds": true }, topRowContent) : React.createElement(Spacer, { height: "var(--zds-space-20)" }),
    children
  );
};

export { PageHeaderBase };
//# sourceMappingURL=PageHeaderBase.es.js.map
